import React from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import Panel from 'Components/Panel/Panel';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const NoScreensAllowed = () => {
    return (
        <LayoutDefault>
            <Panel className={'main-modal'} style={{ display: 'flex', flexDirection: 'column' }}>
                <h1 style={{ width: 'calc(100% - 400px)', textAlign: 'center', margin: '150px 200px 0px 200px', height: 'calc(30% - 150px)' }}>
                    Ainda não há telas disponíveis para o seu usuário. Por favor, entre em contato com o administrador para mais informações.
                </h1>
                <PanelListDefault
                    idsSelected={[]}
                    data={[]}
                    isEmptyPanel={true}
                    style={{ width: '100%', height: '70%' }}
                />
            </Panel>
        </LayoutDefault >
    );
};

export default NoScreensAllowed;